<template>
  <div class="enterprise">
    <ContentView>
      <template slot="operateLeft">
        <el-button @click="addMenu">添加</el-button>
      </template>
      <template slot="contentBox">
        <el-tabs v-model="activeName" type="card" class="menu-tabs" @tab-click="handleClick">
          <el-tab-pane label="网页端" name="0">
            <el-table
              :data="menuTree"
              style="width: 100%;margin-bottom: 20px;"
              row-key="id"
              border
              height="100%"
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >
              <el-table-column prop="menuName" label="菜单名称"></el-table-column>
              <el-table-column prop="menuID" label="id"></el-table-column>
               <el-table-column prop="auth_State" label="状态">
                  <template  slot-scope="scope">
                    <el-tag  v-if="scope.row.auth_State==1" type="success" effect="dark">正常</el-tag>
                    <el-tag  v-if="scope.row.auth_State==0" type="danger" effect="dark">禁用</el-tag>
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="edit(scope.row,'detail')">详情</el-button>
                  <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="小程序端" name="1">
              <el-table
              :data="menuTree"
              style="width: 100%;margin-bottom: 20px;"
              row-key="id"
              border
              height="100%"
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >
              <el-table-column prop="menuName" label="菜单名称"></el-table-column>
              <el-table-column prop="menuID" label="id"></el-table-column>
              <el-table-column prop="auth_State" label="状态">
                  <template  slot-scope="scope">
                    <el-tag  v-if="scope.row.auth_State==1" type="success" effect="dark">正常</el-tag>
                    <el-tag  v-if="scope.row.auth_State==0" type="danger" effect="dark">禁用</el-tag>
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="edit(scope.row,'detail')">详情</el-button>
                  <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

        <div class="menuTree-box">
          <!-- <el-tree
            :data="menuTree"
            node-key="id"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button type="text" size="mini" @click="() => append(data)">添加</el-button>
                <el-button type="text" size="mini" @click="() => edit(data)">修改</el-button>
                <el-button type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
              </span>
            </span>
          </el-tree>-->
        </div>
        <!-- <div class="form-left-box">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="活动名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="活动形式">
              <el-input type="textarea" v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </div>-->
      </template>

      <template slot="pagnation">
        <div>
          <el-button @click="onClose">取 消</el-button>
          <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
        </div>
      </template>
    </ContentView>
    <el-dialog :title="dialogTitle" width="600px" :visible.sync="dialogFormVisible">
      <el-form :model="form" :disabled="formState">
        <el-form-item label="菜单id" :label-width="formLabelWidth">
          <el-input v-model="form.MenuID" :disabled="dialogTitle=='编辑菜单'?false:false" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单名称" :label-width="formLabelWidth">
          <el-input v-model="form.MenuName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级菜单" :label-width="formLabelWidth">
          <el-cascader
          v-if="MenuType==0"
            style="width:100%"
            v-model="form.ParentId"
            :options="menuData"
            :show-all-levels="true"
            :props="{children:'children',label:'menuName',value:'menuID',emitPath:false,checkStrictly: true }"
           
            clearable
          ></el-cascader>
          <el-select  style="width:100%;" v-if="MenuType==1" v-model="form.ParentId" placeholder="请选择">
            <el-option
              v-for="item in groupList"
              :key="item.menuName"
              :label="item.menuName"
              :value="item.menuID">
            </el-option>
          </el-select>
          <!-- <el-input v-model="form.ParentId" autocomplete="off"></el-input> -->
        </el-form-item>
        <el-form-item label="菜单链接" :label-width="formLabelWidth">
          <el-input v-model="form.Auth_Url" :disabled="dialogTitle=='编辑菜单'?false:false" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标类名" :label-width="formLabelWidth">
          <el-input v-model="form.Icon_Url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="权限名称" :label-width="formLabelWidth">
          <el-input v-model="form.PermissonName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" :label-width="formLabelWidth">
          <el-input v-model="form.ControlId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
           <el-radio-group v-model="form.Auth_State">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
        </el-form-item>
       
        <el-form-item label="排序编号" :label-width="formLabelWidth">
          <el-input v-model="form.Morderby" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="formState==false" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from "@/api/public";
import { mapGetters } from "vuex";
export default {
  name: "enterprise",
  data() {
    return {
      tableData: [],
      activeName:'0',
      MenuType:'0',
      searchVal: "",
      formState: false,
      options: [],
      dialogTitle: "",
      dialogFormVisible: false,
      menuTree: [],
      menuData: [],
      formLabelWidth: "100px",
      input: "",
      win: false,
      value: "",
      timesRun: 0,
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      groupList:[],
      form: {
        MenuID: "",
        MenuName: "",
        ParentId: "0",
        Auth_Url: "",
        Icon_Url: "",
        PermissonName: "",
        ControlId: "",
        Morderby: "",
        Auth_Type: "",
        Auth_State:"",
        UserID: "",
      },
    };
  },
  components: {
    ContentView,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  created() {
    this.load();
    this.init()
  },
  methods: {
    //---------------查询区域--------begin-----------
    init(){
      var that = this;
       var obj = {
        url: apiPub.GetGroupNameList,
        data: {},
      };
      $http.request(obj, false, function (res) {
           res.data.push({
            auth_Url: "",
            menuID: "0",
            menuName: "根目录",
          });
        that.groupList=res.data;
      })
    },
    load() {
      var that = this;
      var obj = {
        url: apiPub.UserRoleAllMenu,
        data: {
          MenuType: this.activeName,
        },
      };
      $http.request(obj, false, function (res) {
        // console.log(res);
        if (res.code == 200) {
          var menuTree = JSON.parse(JSON.stringify(res.data));
          // console.log(menuTree);
          menuTree.forEach((el) => {
            if(el.children){
              el.children.forEach((a) => {
              if (Object.keys(a.permissions).length > 0) {
                for (var per in a.permissions) {
                  // console.log("a.id", a.id);
                  // console.log("per", per);
                  if (a.id != per) {
                    a.children.push({
                      id: per,
                      menuID: a.menuID,
                      menuName: a.permissions[per],
                      auth_Url: "",
                      auth_State:a.auth_State,
                      children: [],
                    });
                  }
                }
              }
            });
            }
            
            // console.log(Object.keys(el.permissions))
            // console.log(Object.entries(el.permissions))
          });
          // console.log(menuTree);
          that.menuTree = menuTree;
          var menu = JSON.parse(JSON.stringify(res.data));
          // console.log(menu)
          menu.forEach((el) => {
            if (el.children&&el.children.length > 0) {
              el.children.forEach((a) => {
                // if (a.children.length > 0) {
                // } else {
                //   a.children = "";
                // }
              });
            } else {
              el.children = "";
            }
          });
          menu.push({
            auth_Url: "",
            menuID: "0",
            menuName: "根目录",
          });
          that.menuData = menu;
          // console.log(menu);
        }
      });
    },
    handleClick(tab, event) {
        this.MenuType=tab.name;
        // console.log(tab.name);
        if(tab.name=='1'){
          // this.form = {
          this.form.ParentId=""
          // console.log(this.form)
        }else{
           this.form.ParentId="0"
        }
        this.load();
    },
    handleChange(val) {
      // console.log(val);
    },
    append(data) {
      this.dialogTitle = "添加菜单";
      this.dialogFormVisible = true;
      const newChild = {
        id: "d4791fc7-d620-11ea-a696-00155d006e04",
        menuID: "100",
        menuName: "看板信息",
      };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      data.children.push(newChild);
    },
    addMenu() {
       this.dialogTitle = "添加菜单";
      this.form = {
        MenuID: "",
        MenuName: "",
        ParentId: "0",
        Auth_Url: "",
        Icon_Url: "",
        PermissonName: "",
        ControlId: "",
        Morderby: "",
        Auth_State:"",
        Auth_Type: this.activeName,
        UserID: "",
      };
      this.dialogFormVisible = true;
      this.formState = false;
    },
    edit(data, type) {
      if (type == "detail") {
        this.formState = true;
      } else {
        this.formState = false;
      }
      this.dialogTitle = "编辑菜单";
      var that = this;
      // console.log(data);
      var obj = {
        url: apiPub.GetMenuInfo,
        data: {
          ID: data.id,
        },
      };
      this.dialogFormVisible = true;
      $http.request(obj, false, function (res) {
        // console.log(res);
        if (res.code == 200) {
          // that.form = res.data;
          that.form.ID = res.data.id;
          that.form.MenuID = res.data.menuID;
          that.form.MenuName = res.data.menuName;
          that.form.ParentId = res.data.parentId;
          that.form.Auth_Url = res.data.auth_Url;
          that.form.Icon_Url = res.data.icon_Url;
          that.form.PermissonName = res.data.permissonName;
          that.form.ControlId = res.data.controlId;
          that.form.Morderby = res.data.morderby;
          that.form.Auth_Type = res.data.auth_Type;
          that.form.Auth_State=res.data.auth_State
        }
      });
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex((d) => d.id === data.id);
      children.splice(index, 1);
    },
    // GetNoticeId
    //---------------业务区域--------end-----------
    onClose() {
      this.$router.back(-1);
      //   this.$router.push({ name: 'enterprise'});
    },
    onSubmit() {
      console.log(this.form);
      const that = this;
      // return;
      this.form.UserID = this.currentUser.id;
      if (this.form.ID) {
        var obj = {
          url: apiPub.UpdateMenu,
          data: this.form,
        };
      } else {
        var obj = {
          url: apiPub.AddMenu,
          data: this.form,
        };
      }

      // console.log(this.form);
      // return;
      $http.request(obj, false, function (res) {
        // console.log(res)
        that.$message({
          message: "保存成功",
          type: "success",
        });
        that.dialogFormVisible = false;
        that.load();
      });
    },
    onSave() {
      var that = this;
      var SearchText = this.searchVal || "";
      var obj = {
        url: apiPub.AddNotice,
        data: {
          Content: this.form.content,
          Nstate: "0",
          PushTime: this.form.pushTime,
          PushUser: this.form.pushUser,
          Title: this.form.title,
        },
      };
      $http.request(obj, false, function (res) {
        // console.log(res)
        that.$message({
          message: "保存成功",
          type: "success",
        });
        that.onClose();
        // that.tableData=res.data;
      });
    },
    //---------------表格操作--------begin-----------

    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  },
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.menuTree-box {
  float: left;
  width: 20%;
}
.form-left-box {
  float: left;
  width: 60%;
}
.menu-tabs{
    height: 100%;
}
.menu-tabs /deep/ .el-tabs__content{
    height: 89%;
}
.menu-tabs /deep/ .el-tab-pane{
    height: 100%;
}
.menuTree-box /deep/.el-tree-node__content {
  height: 34px;
}
</style>
